import { api } from "../../config/api";

const basePath = "dashboard/presenca";

/**
 * Get all
 *
 * @param {Object} options
 *
 * @returns {Promise<T>}
 */
export const getAll = (options) => {
	const options_default = {};
	options = Object.assign({}, options_default, options);

	let params = [];
	let params_qs = "";

	if(options.hasOwnProperty("departamento"))
	{
		params.push(`departamento=${options.departamento}`);
	}

	if (options.hasOwnProperty("empresa")) {
		params.push(`empresa=${options.empresa}`);
	}

	if (params.length) {
		params_qs = `?${params.join('&')}`
	}
	return api.get(`${basePath}${params_qs}`)
};
